// Butler's undergraduate majors (#2748). Read on 2026-10-01 from Butler's
// official program finder, Explore All Programs (majors.butler.edu, read
// through its WordPress programs feed: 135 entries, each tagged with its
// program types, degree and college). Kept: every entry whose degree is a
// bachelor's (100). Left out: minors, education licensure-only entries,
// pre-professional tracks with no bachelor's degree, Pre-Pharmacy (a PharmD
// path) and the exploratory (undeclared) options. Quirks: the 2026-2027
// Butler Bulletin (bulletin.butler.edu) sits behind a bot challenge that
// blocked every request after the first, so the program finder is the
// source. The finder tags the College of Health Professions with its old
// "college-of-pharmacy-and-health-sciences" slug; the college name here is
// the Bulletin's. Art Education is tagged with both Jordan College of the
// Arts and the College of Education and sits under the Arts. The finder
// writes "Dance" and "Special Education" programs with an em dash ("Dance"
// then "Performance"); here the dash is a comma. Economics appears in both
// Liberal Arts and Sciences (Bachelor of Arts) and the Lacy School of
// Business (Bachelor of Science), as the finder lists it. Degrees are the
// finder's own wording. The KB's majors list was the starting point; the
// school's list wins.
const majors =
{
    "slug": "butler-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major on Butler's official program finder (majors.butler.edu), grouped by the college that offers it, with the degree it leads to. Minors, pre-professional tracks without a bachelor's degree, exploratory (undeclared) options and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Liberal Arts and Sciences",
            "source": {
                "label": "Butler University, Explore All Programs",
                "url": "https://majors.butler.edu/"
            },
            "majors": [
                {
                    "name": "Actuarial Science",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Anthropology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Anthropology and Psychology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Anthropology and Religious Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Anthropology and Sociology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Astronomy and Astrophysics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biochemistry",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Bioengineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biology",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Chinese",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Classics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Criminology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Criminology and Psychology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Data Science",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "English",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "French",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "German",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "History and Anthropology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "History and Classics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "History and Political Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Individualized Major",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "International Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "International Studies and Religious Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Multilingual",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Neuroscience",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Peace and Conflict Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Philosophy",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Philosophy and Psychology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Philosophy and Religious Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Philosophy and Sociology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Political Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Political Science and Sociology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Psychology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Psychology and Political Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Public Health",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Race, Gender, and Sexuality Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Religious Leadership",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Religious Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Science, Technology, and Society",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sociology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sociology & Psychology with a Specialization in Social Work/Social Policy",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sociology and Criminology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Software Engineering",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Spanish",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Statistics",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Communication",
            "source": {
                "label": "Butler University, Explore All Programs",
                "url": "https://majors.butler.edu/"
            },
            "majors": [
                {
                    "name": "Critical Communication and Media Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Film and Media Production",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Journalism",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Music Industry Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Organizational Communication and Leadership",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Speech, Language, and Hearing Sciences",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sports Media",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Strategic Communication: Public Relations and Advertising",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "College of Education and Human Development",
            "source": {
                "label": "Butler University, Explore All Programs",
                "url": "https://majors.butler.edu/"
            },
            "majors": [
                {
                    "name": "Elementary Education",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Kinesiology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Middle/Secondary Education",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Special Education, Mild Intervention",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Youth and Community Development",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Health Professions",
            "source": {
                "label": "Butler University, Explore All Programs",
                "url": "https://majors.butler.edu/"
            },
            "majors": [
                {
                    "name": "Health Sciences",
                    "degree": "Bachelor of Science Health Science"
                },
                {
                    "name": "Healthcare and Business",
                    "degree": "Bachelor of Science Health Science"
                },
                {
                    "name": "Nursing",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Pre-Respiratory Therapy",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "Jordan College of the Arts",
            "source": {
                "label": "Butler University, Explore All Programs",
                "url": "https://majors.butler.edu/"
            },
            "majors": [
                {
                    "name": "Acting",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Art + Design",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Art Education",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Art History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Arts Administration",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Dance, Arts Administration",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Dance, Pedagogy",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Dance, Performance",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Graphic Design",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Jazz Studies",
                    "degree": "Bachelor of Music"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Music Composition",
                    "degree": "Bachelor of Music"
                },
                {
                    "name": "Music Education",
                    "degree": "Bachelor of Music"
                },
                {
                    "name": "Music Performance",
                    "degree": "Bachelor of Music"
                },
                {
                    "name": "Musical Arts",
                    "degree": "Bachelor of Music Arts"
                },
                {
                    "name": "Performance and Music Education",
                    "degree": "Bachelor of Music"
                },
                {
                    "name": "Photography",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Studio Art",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Theatre",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "Lacy School of Business",
            "source": {
                "label": "Butler University, Explore All Programs",
                "url": "https://majors.butler.edu/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business Technology and Analytics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Entrepreneurship and Innovation",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Finance",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "International Business",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Marketing",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Risk Management and Insurance",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Supply Chain",
                    "degree": "Bachelor of Science"
                }
            ]
        }
    ]
};

export default majors;
